import { api } from "./api";
import { getClickIdsFromContext, getGaClientId, getUtmContext } from "./ga4";

export async function sendFunnelEvent(eventName, payload = {}) {
    try {
        const clickIds = getClickIdsFromContext();
        const utm = getUtmContext();
        await api.post("/events/funnel", {
            event_name: eventName,
            gclid: clickIds.gclid || undefined,
            fbclid: clickIds.fbclid || undefined,
            ga_client_id: getGaClientId() || undefined,
            ...utm,
            ...payload,
        });
    } catch {
        // intentionally silent: analytics should never block UX
    }
}
